import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  users: null
}

// mutations
export const mutations = {

  [types.CREATE_USER] (state, { payload }) {
    state.users.push(payload)
  },

  [types.FETCH_USER_SUCCESS] (state, { users }) {
    state.users = users
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.users = null
  },

  [types.UPDATE_USER2] (state, payload) {
    var item = state.users.find(users => users.id === payload.id)
    Object.assign(item, payload)
  },

  [types.DELETE_USER] (state, payload) {
    var index = state.users.findIndex(users => users.id === payload)
    state.users.splice(index, 1)
  }

}

// actions
export const actions = {

  async fetchUsers2 ({ commit }) {
    try {
      const { data } = await axios.get('/api/users/admin/getUsers')
      console.log(data, 'data')
      commit(types.FETCH_USER_SUCCESS, { users: data })
    } catch (e) {
      console.log(e, 'errooooooooooooooooooooooor')
      // commit(types.FETCH_USER_FAILURE)
    }
  },

  async updateUser2 ({ commit }, payload) {
    commit(types.UPDATE_USER2, payload)
  },

  async createUser ({ commit }, payload) {
    commit(types.CREATE_USER, { payload: payload })
  }

}

// getters
export const getters = {
  getUsers: state => state.users
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/users.js